<template>
    <div class="indexList">
        <div class="haveContent" id="haveContent">
            <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
                <!-- 轮播图 -->
                <div class="swiperBox" v-if="listAllData&&listAllData.hds_list&&listAllData.hds_list.length">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item,index) in listAllData.hds_list" :key="index">
                                <div class="thumbImg">
                                    <img :src="item.thumb.split(',')[0]" alt="">
                                    <p class="titleBunner">{{item.title}}</p>
                                </div>
                            </div>
                            <!-- <div class="swiper-slide">Slide 2</div>
                            <div class="swiper-slide">Slide 3</div> -->
                        </div>
                        <!-- 如果需要分页器 -->
                        <div class="swiper-pagination"></div>
                        
                        <!-- 如果需要导航按钮 -->
                        <!-- <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div> -->
                        
                        <!-- 如果需要滚动条 -->
                        <!-- <div class="swiper-scrollbar"></div> -->
                    </div>
                </div>

                <!-- <div class="wenmingshijain" v-if="listAllData&&listAllData.wmList_arr">
                    <div v-for="(item,index) in listAllData.wmList_arr" :key="index" class="wenmingImgBox" @click="civilizedPractice">
                        <img :src="item.thumb" alt="">
                    </div>
                </div> -->
                <!-- 置顶 -->
                <!-- <roofPlacement :listcontent="listAllData.stickList" v-if="listAllData&&listAllData.stickList"></roofPlacement> -->
                <!-- <div class="outLinkerContent" v-if="listAllData"> -->
                    <div class="outLinkerContentBox" v-if="listAllData">
                        <div class="outLinkerPer" v-for="(item,index) in listAllData.newxmlbList" :key="index" @click="jumpOutside(item)">
                            <div class="outLinkerPerPer">
                                <img :src="item.thumb" alt="">
                            </div>
                            <p class="outLinkerPerTitle">{{item.title}}</p>
                        </div>
                    </div>
                <!-- </div> -->
                <div style="width:100%;height:10px;background:#f8f8f8"></div>
                <!-- 新闻列表 -->
                <newslist :listcontent="newsDataList"></newslist>
            </mescroll-vue>
        </div>
        <!-- <loading :iscomplete="listAllData?false:true" ></loading> -->
    </div>
</template>

<script>
import Swiper from 'swiper';
import '../../assets/swiper.min.css';
import newslist from  './newsList.vue' //新闻列表
// import loading from './loading.vue' //加载动画
// import roofPlacement from './roofPlacement.vue'
// 引入mescroll的vue组件
import MescrollVue from 'mescroll.js/mescroll.vue' //上拉加载，下拉刷新

export default {
    // props:['datalink','currentdisplay','myIndex'],
    props: {
		// datalink: {  //是否显示
		// 	type: String,
		// 	default:()=>"", //必须是一个函数
		// 	required: true,   
        // },
        // currentdisplay:{
        //     type: Number,
        //     default:()=>1, //必须是一个函数
		// 	required: false,  //不是必填项
        // },
        // myIndex:{
        //     type: Number,
        //     default:()=>1, //必须是一个函数
		// 	required: false,  //不是必填项
        // }
    },
    components:{
        newslist ,//新闻列表
        // loading,
        MescrollVue,
        // roofPlacement //置顶
    },
    data(){
        return{
            datalink:'app/index.php?id=xinbanshouye', //链接
            listAllData:null, //页面数据
            newsDataList:[], //新闻列表
            swiperContent:null, //轮播图
            
            mescroll:null, // mescroll实例对象
            // mescrollDown: {
            //     callback: this.downCallback //下拉刷新的回调,别写成downCallback(),多了括号就自动执行方法了
            // },
            mescrollUp: {
                callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
                page: {
                    num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
                    size: 10 // 每页数据的数量
                },
                htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
                noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                toTop: {
                    src: require('../../assets/mescroll/mescroll-totop.png') // 回到顶部按钮的图片路径,支持网络图
                },
                empty: {
                    // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
                    warpId: 'haveContent', // 父布局的id;
                    icon: require('../../assets/mescroll/mescroll-empty.png'), // 图标,支持网络图
                    tip: '暂无相关数据~', // 提示
                    // btntext: '去逛逛 >', // 按钮,默认""
                    // btnClick () { // 点击按钮的回调,默认null
                    //     alert('点击了按钮,具体逻辑自行实现')
                    // }
                },
                auto:true,
                lazyLoad: {
                    use: true // 是否开启懒加载,默认false
                }
            },
        }
    },
    watch: {
        // 如果 `question` 发生改变，这个函数就会运行
        // currentdisplay:{
        //     handler:function (newData) {
        //         if(!this.listAllData){
        //             if(newData==this.myIndex){
        //                 this.indexListDataObain();
        //             }
        //         }
        //     },
        //     immediate: true
        // }
    },
    methods:{
        // 文明实践中心跳转
        civilizedPractice(){
            this.goCivilization(); //跳转文明实践
        },
        // 导航接口
		// indexListDataObain(){
		// 	this.$http.get(this.datalink+'&pageid=1')
        //     .then(resp=>{
        //         // console.log(resp.data);
        //         if(resp.data.status=='ok'){
        //             this.listAllData=resp.data;
        //             this.newsDataList=resp.data.newslist;
        //             this.$nextTick(()=>{
        //                 this.InitializationSwiper();
        //             })
        //         }
        //         // console.log(resp.data);
               
        //     });
        // },
        // 轮播图
        InitializationSwiper(){
            if(this.swiperContent){
                this.swiperContent.destroy();
            }
            var that=this;
            this.swiperContent = new Swiper ('.swiper-container', {
                direction: 'horizontal', // 垂直切换选项
                loop: true, // 循环模式选项
                touchMoveStopPropagation : true, //阻止事件冒泡

                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                },

                on:{
                    click:function(){
                        var x;
                        if(this.clickedIndex==that.listAllData.hds_list.length+1){
                            x=that.listAllData.hds_list[0];
                        }else if(this.clickedIndex==0){
                            x=that.listAllData.hds_list[that.listAllData.hds_list.length-1];
                        }else{
                            x=that.listAllData.hds_list[this.clickedIndex-1];
                        }

                        var link;
                        if(x.matrix_judge==1){
                            link=window.location.href.split("#/")[0]+"#/details?id="+x.medid_id+'&judge'; //链接
                        }else{
                            if(x.linkerapp){
                                link=x.linkerapp; //链接
                            }else{
                                link=window.location.href.split("#/")[0]+"#/details?id="+x.id; //链接
                            }
                        }
                        // window.location.href=link;
                        that.link({url: link,title:x.title});
                    }
                }
                
                // 如果需要前进后退按钮
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                
                // 如果需要滚动条
                // scrollbar: {
                //     el: '.swiper-scrollbar',
                // },
            })        
        },
        // 跳外链
        jumpOutside(item){
            this.link({
                url: item.outlinker,
                title: item.title
            });
        },
        // 上拉加载，下拉刷新
        // mescroll组件初始化的回调,可获取到mescroll对象
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
        upCallback (page, mescroll) {
            var pageNum = page.num; // 页码, 默认从1开始 如何修改从0开始 ?
            // var pageSize = page.size; // 页长, 默认每页10条
            this.$http.get(this.phplinkTwo+this.datalink+'&pageid='+pageNum) //调接口
            .then(resp=>{
                console.log(resp.data);
                if(resp.data.status=='ok'){
                    if (page.num === 1) {
                        this.listAllData=resp.data;
                        this.newsDataList = [];
                        if(this.listAllData.hds_list){
                            this.$nextTick(()=>{
                                this.InitializationSwiper();
                            })
                        }
                    }
                    if(resp.data.newslist){
                        this.newsDataList=this.newsDataList.concat(resp.data.newslist);
                    }
                }else{
                    // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                    mescroll.endErr()
                }
                // mescroll.endByPage(resp.data.newslist.length,resp.data.total);
                // console.log(resp.data);
                this.$nextTick(()=>{
                    if(resp.data.newslist){
                        mescroll.endSuccess(resp.data.newslist.length);
                    }else{
                        mescroll.endSuccess(0);
                    }
                    // if (page.num === 1) {
                    //     this.InitializationSwiper()
                    // }
                })
            }).catch(()=>{
                // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                mescroll.endErr()
            });
        },
        enterDetails(item){
            console.log(item);
        }
    }
}
</script>

<style>
    /*通过fixed固定mescroll的高度*/
    /* .mescroll {
        position: fixed;
        top: 40px;
        bottom: 0;
        height: auto;
    } */
    .indexList{
        width: 100%;
        height: 100%;
        position: relative;
        /* background: red; */
    }
    .indexList .swiper-container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        /* background: red; */
    }  
    .swiperBox{
        width: 100%;
        padding-bottom: 50%;
        position: relative
    }
    .wenmingshijain{
        width: 100%;
        padding: 0px 12px;
        box-sizing:border-box;
    }
    .wenmingImgBox{
        width: 100%;
        height: auto;
    }
    .wenmingImgBox img{
        width: 100%;
        height: auto;
        margin-top: 10px;
        /* margin: 10px auto; */
    }
    .outLinkerContent{
        width: 100%;
        padding-bottom: 20%;
        position: relative;
        /* margin-top: 15px; */
    }
    .outLinkerContentBox{
        /* position: absolute;
        top: 0px;
        left: 0px; */
        width: 100%;
        /* height: 100%; */
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        font-size: 12px;
        text-align: center;
        margin-top: 10px;
    }
    .outLinkerPer{
        width: 20%;
        /* height: 50%; */
    }
    .outLinkerPerPer {
        width: 100%;
        height: calc(100% - 25px);
    }
    .outLinkerPerPer  img{
        width: 40%;
        height: auto;
        /* height: 100%; */
        object-fit: contain;
    }
    .outLinkerPerTitle{
        width: 100%;
        line-height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
    }
    .indexList .haveContent{
        width: 100%;
        height: 100%;
    }
    .indexList .thumbImg{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .indexList .thumbImg img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .indexList .swiper-pagination-bullet{
        width: 20px;
        height: 3px;
        border-radius: 0px;
        background: #ababab;
        opacity: 1;
    }
    .indexList .swiper-pagination-bullet-active{
        background: #fff;
    }
    .indexList .titleBunner{
        position: absolute;
        width: 100%;
        bottom: 30px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        padding: 0px 10px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>